import { AxiosError } from 'axios'
import { toast } from 'sonner'
import * as Sentry from '@sentry/react'

export function handleServerError(error: unknown) {
  // eslint-disable-next-line no-console
  console.log(error)
  
  // Capture error in Sentry before handling
  Sentry.captureException(error)

  let errMsg = 'Có lỗi xảy ra!'

  if (
    error &&
    typeof error === 'object' &&
    'status' in error &&
    Number(error.status) === 204
  ) {
    errMsg = 'Không tìm thấy nội dung.'
  }

  if (error instanceof AxiosError) {
    errMsg = error.response?.data.title
    
    // Add additional context for Sentry
    Sentry.addBreadcrumb({
      category: 'http',
      message: `API Error: ${error.config?.method?.toUpperCase()} ${error.config?.url}`,
      level: 'error',
      data: {
        status: error.response?.status,
        statusText: error.response?.statusText,
      },
    })
  }

  toast.error(errMsg)
}
